import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/home/Home.vue";
import HomeIndex from "@/views/home/HomeIndex.vue";
import Login from "@/views/login/Login.vue";
import ForgotPassword from "@/views/login/ForgotPassword.vue";
import Register from "@/views/register/Register.vue";
import SearchResult from "@/views/search-result/SearchResult.vue";
import DemandDetail from "@/views/demand-detail/DemandDetail.vue";
import UserCenter from "@/views/user-center/UserCenter.vue";
import InfoManage from "@/views/user-center/InfoManage.vue";
import PersonalInfo from "@/views/user-center/PersonalInfo.vue";
import UserAgreement from "@/views/user-center/UserAgreement.vue";
import PrivacyAgreement from "@/views/user-center/PrivacyAgreement.vue";
import ComplaintSuggestion from "@/views/user-center/ComplaintSuggestion.vue";
import RequirementDetails from "@/views/user-center/RequirementDetails.vue";
import About from "@/views/about/About.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/search-result",
    name: "SearchResult",
    component: SearchResult,
  },
  {
    path: "/demand-detail/:id",
    name: "DemandDetail",
    component: DemandDetail,
  },
  {
    path: "/home",
    name: "HomeIndex",
    component: HomeIndex,
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
  {
    path: "/agreement",
    name: "AgreementStandalone",
    component: UserAgreement,
  },
  {
    path: "/privacy",
    name: "PrivacyStandalone",
    component: PrivacyAgreement,
  },
  {
    path: "/user-center",
    component: UserCenter,
    redirect: "/user-center/info-manage",
    children: [
      {
        path: "info-manage",
        name: "InfoManage",
        component: InfoManage,
      },
      {
        path: "personal-info",
        name: "PersonalInfo",
        component: PersonalInfo,
      },
      {
        path: "user-agreement",
        name: "UserAgreement",
        component: UserAgreement,
      },
      {
        path: "privacy-agreement",
        name: "PrivacyAgreement",
        component: PrivacyAgreement,
      },
      {
        path: "complaint-suggestion",
        name: "ComplaintSuggestion",
        component: ComplaintSuggestion,
      },
      {
        path: "requirement-details",
        name: "RequirementDetails",
        component: RequirementDetails,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  // 定义不需要登录即可访问的公开页面
  const publicPages = ["/", "/login", "/forgot-password", "/register", "/agreement", "/privacy", "/about"];

  // 如果用户未登录，且访问的不是公开页面，则重定向到首页 /
  if (!token && !publicPages.includes(to.path)) {
    next("/");
  }
  // 如果用户已登录，且访问的是登录/注册/忘记密码等页面，则重定向到 /home
  else if (token && ["/", "/login", "/forgot-password", "/register"].includes(to.path)) {
    next("/home");
  }
  // 其他情况正常导航
  else {
    next();
  }
});

export default router;
